<rap-add-edit-function-ui [editableFunction]="editableFunction$ | async" [errorMessage]="errorMessage$ | async"
  [title]="title" (createNewFunctionEmitter)="createNewFunction($event)"
  (updateFunctionEmitter)="updateFunction($event)"></rap-add-edit-function-ui>